/* istanbul ignore file */
import CreatePresaleRequestForm from 'domain/sales/opportunity/presale/request/form/CreatePresaleRequestForm';
import { TimelineItem } from 'framework/ui/timeline';
import PresaleRequestTimelineRecordLayout from 'domain/sales/opportunity/presale/request/PresaleRequestTimelineRecordLayout';
import UpdatePresaleRequestForm from 'domain/sales/opportunity/presale/request/form/UpdatePresaleRequestForm';
import { CREATE_PRESALE_REQUEST, PRESALE_ITEMS_TYPE } from 'domain/sales/opportunity/opportunityService';
import type { Data } from 'framework/types';
import { get } from 'lodash';

const usePresaleRequestItem = () => ({
  AddForm: CreatePresaleRequestForm,
  UpdateForm: UpdatePresaleRequestForm,
  isApplicable: (item: any) => item?.presaleRequest,
  source: 'presaleRequest',
  urlPostfix: PRESALE_ITEMS_TYPE.PRESALE_REQUEST,
  RecordLayout: PresaleRequestTimelineRecordLayout,
  name: 'Presale Request',
  permissionToCheck: CREATE_PRESALE_REQUEST,
  additionalAfterAddSubmit: (item: TimelineItem, parentContext?: Data) => {
    const oppState = parentContext?.getValueBySource('stateStep');
    const requestStatus = get(item, 'requestStatus');
    if (oppState === 'NEW' && requestStatus === 'SUBMITTED') {
      window.location.reload(); // reload page for fetch actual state
    }
  },
  additionalAfterUpdateSubmit: (item: TimelineItem, parentContext?: Data) => {
    const oppState = parentContext?.getValueBySource('stateStep');
    const requestStatus = get(item, 'requestStatus');
    if (oppState === 'NEW' && requestStatus === 'SUBMITTED') {
      window.location.reload(); // reload page for fetch actual state
    }
  },
});

export default usePresaleRequestItem;
